module.exports = __webpack_public_path__ + "img/90401b67cb9df5346b3b9e23d5b37914.png";